import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "account",
  "use": "account-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 20 20\" id=\"account\"><path stroke=\"currentColor\" stroke-width=\"2.5\" d=\"M18.75 14c0 1.045-.713 2.205-2.322 3.17-1.585.951-3.854 1.58-6.428 1.58s-4.843-.628-6.428-1.58C1.962 16.206 1.25 15.046 1.25 14s.713-2.205 2.322-3.17C5.157 9.878 7.426 9.25 10 9.25s4.843.629 6.428 1.58c1.61.965 2.322 2.125 2.322 3.17z\" /><circle cx=\"10\" cy=\"3.25\" r=\"3.25\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol